const state = {
  nudging: null,
  nudgingDelay: 0,
  nudgingShowCounter: 0,
  showNudgingByEvent: false
}

const getters = {}

const actions = {
  setNudging: ({ commit }, nudging) => {
    commit('setNudging', nudging)
  },

  closeNudgeConv: ({ commit }) => {
    commit('setNudging', false)
    commit('setNudgingByEvent', null)
  },

  setNudgingDelay: ({ commit }, nudgingDelay) => {
    commit('setNudgingDelay', nudgingDelay)
  },

  openChat: ({ commit, dispatch }) => {
    dispatch('uistate/open', true, { root: true })
    commit('setNudging', false)
  },

  incrementNudgingShowCounter: ({ commit }) => {
    commit('incrementNudgingShowCounter')
  },

  setNudgingByEvent: ({ commit }, value = false) => {
    commit('setNudgingByEvent', value)
  }
}

const mutations = {
  setNudging: (state, nudging = null) => {
    state.nudging = nudging
    if (!nudging && state.showNudgingByEvent) {
      state.showNudgingByEvent = false
    }
  },
  setNudgingByEvent: (state, value) => {
    if (state.showNudgingByEvent !== null) {
      state.showNudgingByEvent = value
    }
  },

  setNudgingDelay: (state, nudgingDelay) => {
    state.nudgingDelay = nudgingDelay
  },

  incrementNudgingShowCounter: (state) => {
    state.nudgingShowCounter++
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
